var popupController,popupWindow;

(function(){
  
  $(document).ready(function(){
    initPopup();
  });
  
  var dialog;
  function initPopup(){
    /*
    var iframe = $('<iframe frameborder="0" marginwidth="0" marginheight="0" allowfullscreen></iframe>');
    var closePopupBtn = $('<div class="close-popup">X</div>');
    dialog = $("<div></div>").append(iframe).append(closePopupBtn).appendTo("body").dialog({
      autoOpen: false,
      modal: true,
      classes: {
        "ui-dialog": "ticket-dialog"
      },      
      resizable: false,
      width: "auto",
      height: "auto",
      open: function(){
        $('.ui-widget-overlay').addClass('ticket-dialog-overlay');
        $('html').css('overflow','hidden');
      },
      close: function () {
        iframe.attr("src", "");
        $('html').css('overflow','visibile');
      }
    });
    */

    $(".open-product-popup").on("click", function (e) {
      e.preventDefault();
      
      var popupWidth = Math.min(691,($(window).width()-9)),
      //var popupWidth = Math.min(350,($(window).width()-9)),
          popupHeight = 600, //Math.max(600,($(window).height() * 0.8)),
          popupLeft = (($(window).width() - popupWidth)/2),
          popupTop = (($(window).height() - popupHeight)/2),
          popupOptions = "menubar=no,location=no,resizable=no,scrollbars=no,status=no,width="+popupWidth+",height="+popupHeight+",left="+popupLeft+",top="+popupTop;
      
      popupWindow = window.open($(this).attr("data-href"),'Product details', popupOptions);
      

      /*
      var src = $(this).attr("data-href");
      var title = "Titolo";

      console.log("src",src);      
      
      var iframeWidth = Math.min(691,($(window).width()-9));
      
      iframe.attr({
        width: iframeWidth,
        height: 500,
        src: src
      });
      dialog.dialog("option", "title", title).dialog("open");
      */
    });
    /*
    $(closePopupBtn).on("click", function(e){
      e.preventDefault();
      dialog.dialog("close");
    });
    */
  }
  
  popupController = {
    closeDialogAndUpdateCart: function(){
      //dialog.dialog("close");
      popupWindow.close();
      //location.reload(true);
      //location.href = location.href + '?openCart=true';
      var hr = location.href;
      if (hr.indexOf("#")>-1){
        hr = hr.substring(0,hr.indexOf("#"));
      }
      location.assign(hr + '?openCart=true');
    }
  };
  
}())